import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  updateUI,
  createRequest,
  updateRequest,
  fetchDeviceTypeRequest,
  shipmentValidationRequest
} from "../../../store/actions/deviceProfile";
import {
  fetchRequest as fetchLocationRequest
} from "../../../store/actions/location";
import BackArrowIcon from "../../../assets/left-arrow.svg";
import CreateDeviceProfileStep1 from "./step1";
import CreateDeviceProfileStep2 from "./step2";
import CreateDeviceProfileStep3 from "./step3";
import CreateNonShipDeviceProfileStep3 from "./shared/nonshiploc/index"
import CreateDeviceProfileStep4 from "./step4";
import CreateDeviceProfileStepReview from "./review";
import { IsRequiredValidation, validateSchedules } from "./formValidation";
import getSingleDeviceProfile from "../utility/getSingleDeviceProfile";
import setLocationIntoStep3 from "../utility/setLocationIntostep3";
import { CircularProgress } from "@mui/material";

function CreateDeviceProfile() {
  const dispatch = useDispatch();
  const {
    isCreateOpen,
    loading,
    forms,
    type,
    step,
    formFields,
    deviceProfiles,
    selectedDeviceProfile,
    deviceTypes,
  } = useSelector((state) => ({
    isCreateOpen: state.deviceProfile.ui.form.isOpen,
    loading: state.deviceProfile.isLoading.isCreated,
    forms: state.deviceProfile.ui.form,
    type: state.deviceProfile.ui.form.type,
    step: state.deviceProfile.ui.form.step,
    formFields: state.deviceProfile.ui.form.fields,
    deviceProfiles: state.deviceProfile.data.devices,
    selectedDeviceProfile: Array.isArray(
      state.deviceProfile.ui.form.deviceTypes
    )
      ? state.deviceProfile.ui.form.deviceTypes.filter(
          (deviceType) =>
            deviceType.value ===
            state.deviceProfile.ui.form.fields.step1.deviceType.value
        )
      : [],
    deviceTypes: state.deviceProfile.ui.form.deviceTypes,
  }));

  const handleOk = () => {
    dispatch(
      updateUI({
        key: "form",
        value: {
          type: "",
          isOpen: false,
        },
      })
    );
  };
  const handleAdd = () => {
    dispatch(createRequest());
  };

  const handleNext = () => {
    let validatedFields = {};
    let isInValidFields = false;
    let nextStep = 0;
    const model = selectedDeviceProfile?.[0]?.devicemodel?.toLowerCase();
    const profileType = formFields?.step1?.profileType?.value?.toLowerCase()?.trim();
    const expectedStep =
      model === "gat" ? 4 :
      model === "ble" ? (profileType === "shipment" ? 2 : 3) :
      null;
    // if (
    //   (Array.isArray(selectedDeviceProfile) &&
    //     selectedDeviceProfile.length > 0 &&
    //     selectedDeviceProfile[0]?.devicemodel?.toLowerCase() === "gat" &&
    //     step === 4) ||
    //   (Array.isArray(selectedDeviceProfile) &&
    //     selectedDeviceProfile.length > 0 &&
    //     selectedDeviceProfile[0]?.devicemodel?.toLowerCase() === "ble" &&
    //      step === 2)
        
    //    // step === formFields?.step1?.profileType?.value?.toLowerCase().trim() === "shipment"? 2: 3)
    // ) 
    if (
  Array.isArray(selectedDeviceProfile) &&
  selectedDeviceProfile.length > 0 &&
  (model === "gat" || model === "ble") &&
  step === expectedStep
)
    {
      dispatch(
        updateUI({
          key: "form",
          value: {
            step: -1,
          },
        })
      );
      return;
    }

    let fields = formFields[`step${step}`];

    const requiredFieldsArr = Object.entries(fields);
    let requiredFields = {};

    if (Array.isArray(requiredFieldsArr) && requiredFieldsArr.length > 0) {
      requiredFieldsArr
        .filter((rFA) => rFA[1]?.isRequired)
        .forEach((rFA) => {
          requiredFields = {
            ...requiredFields,
            [rFA[0]]: rFA[1],
          };
        });
    }

    const fieldKeys = Object.keys(requiredFields);

    for (let field of fieldKeys) {
      const validator = IsRequiredValidation(
        field,
        requiredFields[field].value || ""
      );
      validatedFields = {
        ...validatedFields,
        [field]: {
          ...requiredFields[field],
          ...validator,
          value: requiredFields[field].value,
        },
      };
    }

    for (let field of fieldKeys) {
      if (validatedFields[field].isValid === false) {
        isInValidFields = true;
        break;
      }
    }

    if (isInValidFields) {
      dispatch(
        updateUI({
          key: "form",
          value: {
            step,
            fields: {
              ...formFields,
              [`step${step}`]: {
                ...formFields[`step${step}`],
                ...validatedFields,
              },
            },
          },
        })
      );
    } else {
      if (step === 1) {
       // nextStep = step + 1;
          nextStep = model?.toLowerCase() === "gat" && profileType?.toLowerCase() === "nonshipment"
                    ? step + 2
                    : step + 1;
        dispatch(
          updateUI({
            key: "form",
            value: {
              ...forms,
              step: nextStep,
              fields: {
                ...formFields,
                [`step${step}`]: {
                  ...formFields[`step${step}`],
                  ...validatedFields,
                },
              },
            },
          })
        );
        return;
      } else if (step === 2) {
        const scheduleValidation = validateSchedules(formFields.step2);
        if (!scheduleValidation.isValid) {
          return;
        }
        nextStep = step + 1;
        dispatch(
          updateUI({
            key: "form",
            value: {
              ...forms,
              step: nextStep,
              fields: {
                ...formFields,
                step3: {
                  currentLocationIndex: null,
                  locations:
                    formFields.step3.locations.length > 1
                      ? formFields.step3.locations
                      : [
                          {
                            currentLocation: "",
                            existing: {
                              shipping: {
                                isValid: true,
                                class: "",
                                value: "Origin",
                                error: "",
                              },
                              pointName: {
                                isValid: false,
                                class: "",
                                value: "",
                                error: "",
                              },
                              address: {
                                isValid: false,
                                class: "",
                                value: "",
                                error: "",
                                mapBoxTheme: {
                                  cssText: `
                                  .Input {
                                      height: 44px;
                                      font-size: 1rem;
                                      font-weight: 400;
                                      color: #212529;
                                      font-family: system-ui;
                                      pointer-events: none;
                                  }
                                  .ClearBtn {
                                      display: none !important;
                                  }
                              `,
                                  variables: {
                                    unit: "14px",
                                    padding: "0.5em",
                                    border: "1px solid rgba(111, 113, 113, 1)",
                                    borderRadius: "4px",
                                    boxShadow: "none",
                                  },
                                },
                              },
                              latitude: {
                                isValid: false,
                                class: "",
                                value: "",
                                error: "",
                              },
                              trigger: {
                                isValid: false,
                                class: "",
                                value: "entry and exit",
                                error: "",
                              },
                              longitude: {
                                isValid: false,
                                class: "",
                                value: "",
                                error: "",
                              },
                              radius: {
                                isValid: false,
                                class: "",
                                value: "",
                                error: "",
                              },
                              alerttype: {
                                isValid: false,
                                class: "",
                                value: "notification",
                                error: "",
                              },
                              alertgroup: {
                                isValid: false,
                                class: "",
                                value: undefined,
                                error: "",
                              },
                            },
                            new: {
                              shipping: {
                                isValid: true,
                                class: "",
                                value: "Origin",
                                error: "",
                              },
                              pointName: {
                                isValid: false,
                                class: "",
                                value: "",
                                error: "",
                              },
                              address: {
                                isValid: false,
                                class: "",
                                value: "",
                                error: "",
                                mapBoxTheme: {
                                  cssText: `
                                  .Input {
                                      height: 44px;
                                      font-size: 1rem;
                                      font-weight: 400;
                                      color: #212529;
                                      font-family: system-ui;
                                      pointer-events: none;
                                  }
                                  .ClearBtn {
                                      display: none !important;
                                  }
                              `,
                                  variables: {
                                    unit: "14px",
                                    padding: "0.5em",
                                    border: "1px solid rgba(111, 113, 113, 1)",
                                    borderRadius: "4px",
                                    boxShadow: "none",
                                  },
                                },
                              },
                              latitude: {
                                isValid: false,
                                class: "",
                                value: "",
                                error: "",
                              },
                              trigger: {
                                isValid: false,
                                class: "",
                                value: "entry and exit",
                                error: "",
                              },
                              longitude: {
                                isValid: false,
                                class: "",
                                value: "",
                                error: "",
                              },
                              radius: {
                                isValid: false,
                                class: "",
                                value: "",
                                error: "",
                              },
                              alerttype: {
                                isValid: false,
                                class: "",
                                value: "notification",
                                error: "",
                              },
                              alertgroup: {
                                isValid: false,
                                class: "",
                                value: undefined,
                                error: "",
                              },
                            },
                          },
                          {
                            currentLocation: "",
                            existing: {
                              shipping: {
                                isValid: true,
                                class: "",
                                value: "Destination",
                                error: "",
                              },
                              pointName: {
                                isValid: false,
                                class: "",
                                value: "",
                                error: "",
                              },
                              address: {
                                isValid: false,
                                class: "",
                                value: "",
                                error: "",
                                mapBoxTheme: {
                                  cssText: `
                                  .Input {
                                      height: 44px;
                                      font-size: 1rem;
                                      font-weight: 400;
                                      color: #212529;
                                      font-family: system-ui;
                                      pointer-events: none;
                                  }
                                  .ClearBtn {
                                      display: none !important;
                                  }
                              `,
                                  variables: {
                                    unit: "14px",
                                    padding: "0.5em",
                                    border: "1px solid rgba(111, 113, 113, 1)",
                                    borderRadius: "4px",
                                    boxShadow: "none",
                                  },
                                },
                              },
                              latitude: {
                                isValid: false,
                                class: "",
                                value: "",
                                error: "",
                              },
                              trigger: {
                                isValid: false,
                                class: "",
                                value: "entry and exit",
                                error: "",
                              },
                              longitude: {
                                isValid: false,
                                class: "",
                                value: "",
                                error: "",
                              },
                              radius: {
                                isValid: false,
                                class: "",
                                value: "",
                                error: "",
                              },
                              alerttype: {
                                isValid: false,
                                class: "",
                                value: "notification",
                                error: "",
                              },
                              alertgroup: {
                                isValid: false,
                                class: "",
                                value: undefined,
                                error: "",
                              },
                            },
                            new: {
                              shipping: {
                                isValid: true,
                                class: "",
                                value: "Destination",
                                error: "",
                              },
                              pointName: {
                                isValid: false,
                                class: "",
                                value: "",
                                error: "",
                              },
                              address: {
                                isValid: false,
                                class: "",
                                value: "",
                                error: "",
                                mapBoxTheme: {
                                  cssText: `
                                  .Input {
                                      height: 44px;
                                      font-size: 1rem;
                                      font-weight: 400;
                                      color: #212529;
                                      font-family: system-ui;
                                      pointer-events: none;
                                  }
                                  .ClearBtn {
                                      display: none !important;
                                  }
                              `,
                                  variables: {
                                    unit: "14px",
                                    padding: "0.5em",
                                    border: "1px solid rgba(111, 113, 113, 1)",
                                    borderRadius: "4px",
                                    boxShadow: "none",
                                  },
                                },
                              },
                              latitude: {
                                isValid: false,
                                class: "",
                                value: "",
                                error: "",
                              },
                              trigger: {
                                isValid: false,
                                class: "",
                                value: "entry and exit",
                                error: "",
                              },
                              longitude: {
                                isValid: false,
                                class: "",
                                value: "",
                                error: "",
                              },
                              radius: {
                                isValid: false,
                                class: "",
                                value: "",
                                error: "",
                              },
                              alerttype: {
                                isValid: false,
                                class: "",
                                value: "notification",
                                error: "",
                              },
                              alertgroup: {
                                isValid: false,
                                class: "",
                                value: undefined,
                                error: "",
                              },
                            },
                          },
                        ],
                },
              },
            },
          })
        );
        return;
      } else if (step === 3 && formFields?.step1?.profileType?.value !== "nonshipment") {
        let locations = formFields.step3.locations || [];

        if (locations?.length === 0) {
          locations = [
            {
              currentLocation: "",
              existing: {
                shipping: {
                  isValid: true,
                  class: "",
                  value: "Origin",
                  error: "",
                },
                pointName: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                address: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                  mapBoxTheme: {
                    cssText: `
                                  .Input {
                                      height: 44px;
                                      font-size: 1rem;
                                      font-weight: 400;
                                      color: #212529;
                                      font-family: system-ui;
                                      pointer-events: none;
                                  }
                                  .ClearBtn {
                                      display: none !important;
                                  }
                              `,
                    variables: {
                      unit: "14px",
                      padding: "0.5em",
                      border: "1px solid rgba(111, 113, 113, 1)",
                      borderRadius: "4px",
                      boxShadow: "none",
                    },
                  },
                },
                latitude: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                trigger: {
                  isValid: false,
                  class: "",
                  value: "entry and exit",
                  error: "",
                },
                longitude: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                radius: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                alerttype: {
                  isValid: false,
                  class: "",
                  value: "notification",
                  error: "",
                },
                alertgroup: {
                  isValid: false,
                  class: "",
                  value: undefined,
                  error: "",
                },
              },
              new: {
                shipping: {
                  isValid: true,
                  class: "",
                  value: "Origin",
                  error: "",
                },
                pointName: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                address: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                  mapBoxTheme: {
                    cssText: `
                                  .Input {
                                      height: 44px;
                                      font-size: 1rem;
                                      font-weight: 400;
                                      color: #212529;
                                      font-family: system-ui;
                                      pointer-events: none;
                                  }
                                  .ClearBtn {
                                      display: none !important;
                                  }
                              `,
                    variables: {
                      unit: "14px",
                      padding: "0.5em",
                      border: "1px solid rgba(111, 113, 113, 1)",
                      borderRadius: "4px",
                      boxShadow: "none",
                    },
                  },
                },
                latitude: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                trigger: {
                  isValid: false,
                  class: "",
                  value: "entry and exit",
                  error: "",
                },
                longitude: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                radius: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                alerttype: {
                  isValid: false,
                  class: "",
                  value: "notification",
                  error: "",
                },
                alertgroup: {
                  isValid: false,
                  class: "",
                  value: undefined,
                  error: "",
                },
              },
            },
            {
              currentLocation: "",
              existing: {
                shipping: {
                  isValid: true,
                  class: "",
                  value: "Destination",
                  error: "",
                },
                pointName: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                address: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                  mapBoxTheme: {
                    cssText: `
                                  .Input {
                                      height: 44px;
                                      font-size: 1rem;
                                      font-weight: 400;
                                      color: #212529;
                                      font-family: system-ui;
                                      pointer-events: none;
                                  }
                                  .ClearBtn {
                                      display: none !important;
                                  }
                              `,
                    variables: {
                      unit: "14px",
                      padding: "0.5em",
                      border: "1px solid rgba(111, 113, 113, 1)",
                      borderRadius: "4px",
                      boxShadow: "none",
                    },
                  },
                },
                latitude: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                trigger: {
                  isValid: false,
                  class: "",
                  value: "entry and exit",
                  error: "",
                },
                longitude: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                radius: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                alerttype: {
                  isValid: false,
                  class: "",
                  value: "notification",
                  error: "",
                },
                alertgroup: {
                  isValid: false,
                  class: "",
                  value: undefined,
                  error: "",
                },
              },
              new: {
                shipping: {
                  isValid: true,
                  class: "",
                  value: "Destination",
                  error: "",
                },
                pointName: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                address: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                  mapBoxTheme: {
                    cssText: `
                                  .Input {
                                      height: 44px;
                                      font-size: 1rem;
                                      font-weight: 400;
                                      color: #212529;
                                      font-family: system-ui;
                                      pointer-events: none;
                                  }
                                  .ClearBtn {
                                      display: none !important;
                                  }
                              `,
                    variables: {
                      unit: "14px",
                      padding: "0.5em",
                      border: "1px solid rgba(111, 113, 113, 1)",
                      borderRadius: "4px",
                      boxShadow: "none",
                    },
                  },
                },
                latitude: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                trigger: {
                  isValid: false,
                  class: "",
                  value: "entry and exit",
                  error: "",
                },
                longitude: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                radius: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                alerttype: {
                  isValid: false,
                  class: "",
                  value: "notification",
                  error: "",
                },
                alertgroup: {
                  isValid: false,
                  class: "",
                  value: undefined,
                  error: "",
                },
              },
            },
          ];
        } else {
          const result = setLocationIntoStep3(locations);

          locations = result.locations;
          if (result.isValidForNext) {
            nextStep = step + 1;
          } else {
            nextStep = step;
          }
        }

        dispatch(
          updateUI({
            key: "form",
            value: {
              ...forms,
              step: nextStep,
              fields: {
                ...formFields,
                step3: {
                  locations,
                },
              },
            },
          })
        );
        return;
      }

      nextStep = step + 1;
      dispatch(
        updateUI({
          key: "form",
          value: {
            ...forms,
            step: nextStep,
            fields: {
              ...formFields,
              [`step${step}`]: {
                ...formFields[`step${step}`],
                ...validatedFields,
              },
            },
          },
        })
      );
    }
  };

  const handleBackAndCancelButton = () => {
      const model = selectedDeviceProfile?.[0]?.devicemodel?.toLowerCase();
    const profileType = formFields?.step1?.profileType?.value?.toLowerCase()?.trim();
    const expectedStep =
      model === "ble" ? (profileType === "shipment" ? 2 : 3) :
      null;
    if (
      Array.isArray(selectedDeviceProfile) &&
      selectedDeviceProfile.length > 0 &&
      selectedDeviceProfile[0]?.devicemodel?.toLowerCase() === "gat"
    ) {
      dispatch(
        updateUI({
          key: "form",
          value: {
            selectedProfile: {},
           // step: step === -1 ? 4 : step - 1,
            step: step === -1 ? 4 : model?.toLowerCase() === "gat" && profileType?.toLowerCase() === "nonshipment" && step===3
                    ? step - 2
                    : step - 1
          },
        })
      );
    } else if (
      Array.isArray(selectedDeviceProfile) &&
      selectedDeviceProfile.length > 0 &&
      selectedDeviceProfile[0]?.devicemodel?.toLowerCase() === "ble"
    ) {
      dispatch(
        updateUI({
          key: "form",
          value: {
            selectedProfile: {},
            step: step === -1 ? expectedStep : step - 1,
          },
        })
      );
    }
  };
  const handleCancelButton = () => {
    dispatch(
      updateUI({
        key: "form",
        value: {
          isOpen: false,
          type: "",
          step: 1,
          isSaved: false,
          single: {
            id: null,
            name: "",
          },
          fields: {
            step1: {
              profileName: {
                isValid: true,
                isRequired: true,
                class: "",
                value: "",
                error: "",
              },
               profileType: {
                isValid: true,
                isRequired: true,
                class: "",
                value: "shipment",
                error: "",
              },
              deviceType: {
                isValid: true,
                isRequired: true,
                class: "",
                value: undefined,
                error: "",
              },
              description: {
                isValid: true,
                isRequired: false,
                class: "",
                value: "",
                error: "",
              },
              attributes: [],
            },
            step2: {
              autoResolveForAllAlert: true,
            },
            step3: {
              locations: [
                {
                  currentLocation: "",
                  existing: {
                    shipping: {
                      isValid: true,
                      class: "",
                      value: "Origin",
                      error: "",
                    },
                    pointName: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    address: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                      mapBoxTheme: {
                        cssText: `
                                  .Input {
                                      height: 44px;
                                      font-size: 1rem;
                                      font-weight: 400;
                                      color: #212529;
                                      font-family: system-ui;
                                      pointer-events: none;
                                  }
                                  .ClearBtn {
                                      display: none !important;
                                  }
                              `,
                        variables: {
                          unit: "14px",
                          padding: "0.5em",
                          border: "1px solid rgba(111, 113, 113, 1)",
                          borderRadius: "4px",
                          boxShadow: "none",
                        },
                      },
                    },
                    latitude: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    trigger: {
                      isValid: false,
                      class: "",
                      value: "entry and exit",
                      error: "",
                    },
                    longitude: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    radius: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    alerttype: {
                      isValid: false,
                      class: "",
                      value: "notification",
                      error: "",
                    },
                    alertgroup: {
                      isValid: false,
                      class: "",
                      value: undefined,
                      error: "",
                    },
                  },
                  new: {
                    shipping: {
                      isValid: true,
                      class: "",
                      value: "Origin",
                      error: "",
                    },
                    pointName: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    address: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                      mapBoxTheme: {
                        cssText: `
                                  .Input {
                                      height: 44px;
                                      font-size: 1rem;
                                      font-weight: 400;
                                      color: #212529;
                                      font-family: system-ui;
                                      pointer-events: none;
                                  }
                                  .ClearBtn {
                                      display: none !important;
                                  }
                              `,
                        variables: {
                          unit: "14px",
                          padding: "0.5em",
                          border: "1px solid rgba(111, 113, 113, 1)",
                          borderRadius: "4px",
                          boxShadow: "none",
                        },
                      },
                    },
                    latitude: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    trigger: {
                      isValid: false,
                      class: "",
                      value: "entry and exit",
                      error: "",
                    },
                    longitude: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    radius: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    alerttype: {
                      isValid: false,
                      class: "",
                      value: "notification",
                      error: "",
                    },
                    alertgroup: {
                      isValid: false,
                      class: "",
                      value: undefined,
                      error: "",
                    },
                  },
                },
                {
                  currentLocation: "",
                  existing: {
                    shipping: {
                      isValid: true,
                      class: "",
                      value: "Destination",
                      error: "",
                    },
                    pointName: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    address: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                      mapBoxTheme: {
                        cssText: `
                                  .Input {
                                      height: 44px;
                                      font-size: 1rem;
                                      font-weight: 400;
                                      color: #212529;
                                      font-family: system-ui;
                                      pointer-events: none;
                                  }
                                  .ClearBtn {
                                      display: none !important;
                                  }
                              `,
                        variables: {
                          unit: "14px",
                          padding: "0.5em",
                          border: "1px solid rgba(111, 113, 113, 1)",
                          borderRadius: "4px",
                          boxShadow: "none",
                        },
                      },
                    },
                    latitude: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    trigger: {
                      isValid: false,
                      class: "",
                      value: "entry and exit",
                      error: "",
                    },
                    longitude: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    radius: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    alerttype: {
                      isValid: false,
                      class: "",
                      value: "notification",
                      error: "",
                    },
                    alertgroup: {
                      isValid: false,
                      class: "",
                      value: undefined,
                      error: "",
                    },
                  },
                  new: {
                    shipping: {
                      isValid: true,
                      class: "",
                      value: "Destination",
                      error: "",
                    },
                    pointName: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    address: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                      mapBoxTheme: {
                        cssText: `
                                  .Input {
                                      height: 44px;
                                      font-size: 1rem;
                                      font-weight: 400;
                                      color: #212529;
                                      font-family: system-ui;
                                      pointer-events: none;
                                  }
                                  .ClearBtn {
                                      display: none !important;
                                  }
                              `,
                        variables: {
                          unit: "14px",
                          padding: "0.5em",
                          border: "1px solid rgba(111, 113, 113, 1)",
                          borderRadius: "4px",
                          boxShadow: "none",
                        },
                      },
                    },
                    latitude: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    trigger: {
                      isValid: false,
                      class: "",
                      value: "entry and exit",
                      error: "",
                    },
                    longitude: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    radius: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    alerttype: {
                      isValid: false,
                      class: "",
                      value: "notification",
                      error: "",
                    },
                    alertgroup: {
                      isValid: false,
                      class: "",
                      value: undefined,
                      error: "",
                    },
                  },
                },
              ],
            },
              nonshipstep3: {
          nonshipsetalert: false,
          nonshipusecase:{
           useCase: {
            isValid: false,
            class: "",
            value: "Inventory management",
            error: "",
          },
          },
          inventoryMgmt: {
            assetthreshold: {
              isValid: false,
              class: "",
              value: "",
              error: "",
            },
           assettype: {
              isValid: false,
              class: "",
              value: [],
              error: "",
            },
          alerttype: {
            isValid: false,
            class: "",
            value: "notification",
            error: "",
          },
          alertgroup: {
            isValid: false,
            class: "",
            value: undefined,
            error: "",
          },
          },
           nonshipbleloc: {
            locationzone: {
              isValid: false,
              class: "",
              value: [],
              error: "",
            },
            trigger: {
              isValid: false,
              class: "",
              value: "entry and exit",
              error: "",
            },
          alerttype: {
            isValid: false,
            class: "",
            value: "notification",
            error: "",
          },
          alertgroup: {
            isValid: false,
            class: "",
            value: undefined,
            error: "",
          },
          },
        },
            step4: {
              reportingFrequency: {
                value: {
                  isValid: true,
                  class: "",
                  value: "5",
                  error: "",
                },
                unit: {
                  isValid: true,
                  class: "",
                  value: "minutes",
                  error: "",
                },
              },
              monitorFrequency: {
                value: {
                  isValid: true,
                  class: "",
                  value: "5",
                  error: "",
                },
                unit: {
                  isValid: true,
                  class: "",
                  value: "minutes",
                  error: "",
                },
              },
            },
          },
        },
      })
    );
  };

  const handleEdit = (id) => {
    const selectedId = forms?.single?.id;
    const name = forms?.single?.name;
    const singleDeviceProfile = getSingleDeviceProfile(
      deviceProfiles,
      selectedId,
      deviceTypes
    );
    if (singleDeviceProfile === null) return;
     dispatch(shipmentValidationRequest({
      id:selectedId,
      actionType: "edit",
      callback: ({ hasActiveShipments }) => {
        if (hasActiveShipments) {
            dispatch(
            updateUI({
              key: "form",
              value: {
                isOpen: false,
                type: "view",
                step: -1,
                ...singleDeviceProfile,
              },
            })
          );
          dispatch(updateUI({
            key: "activeShipmentPopup",
            value: {
              isOpen: true,
              type: "editWarning",
              id:selectedId
            }
          }));
        } else {
            dispatch(fetchLocationRequest(-1));
            dispatch(fetchDeviceTypeRequest());
            dispatch(
              updateUI({
                key: "form",
                value: {
                  ...forms,
                  type: "edit",
                  step: 1,
                  ...singleDeviceProfile,
                  single: {
                    ...singleDeviceProfile.single,
                    name,
                    id: selectedId,
                  },
                  fields: {
                    ...singleDeviceProfile.fields,
                  },
                },
              })
            );
                }
              }
            }));
  };

  // const handleEdit = (id) => {
  //   const selectedId = forms?.single?.id;
  //   const name = forms?.single?.name;
  //   const singleDeviceProfile = getSingleDeviceProfile(
  //     deviceProfiles,
  //     selectedId,
  //     deviceTypes
  //   );
  //   if (singleDeviceProfile === null) return;
  //   dispatch(fetchLocationRequest(-1));
  //   dispatch(fetchDeviceTypeRequest());
  //   dispatch(
  //     updateUI({
  //       key: "form",
  //       value: {
  //         ...forms,
  //         type: "edit",
  //         step: 1,
  //         ...singleDeviceProfile,
  //         single: {
  //           ...singleDeviceProfile.single,
  //           name,
  //           id: selectedId,
  //         },
  //         fields: {
  //           ...singleDeviceProfile.fields,
  //         },
  //       },
  //     })
  //   );
  // };

  const handleSave = () => {
    dispatch(updateRequest());
  };

  return (
    <Modal
      className="d-flex flex-column justify-content-center align-items-center p-2 shipment-clone"
      title=""
      open={isCreateOpen}
      onOk={handleOk}
      onCancel={handleCancelButton}
      width={{
        xs: "90%",
        sm: "80%",
        md: "90%",
        lg: "88%",
        xl: "85%",
        xxl: "80%",
      }}
      footer={() => {
        if (step === -1 && type === "view") {
          return [
            <button key="back" className="cancel" onClick={handleCancelButton}>
              Cancel
            </button>,
            <button
              key="submit"
              className="update"
              onClick={() => handleEdit()}
            >
              Edit
            </button>,
          ];
        } else if (step === -1) {
          if (type === "edit") {
            return [
              <button
                key="back"
                className="cancel"
                onClick={handleBackAndCancelButton}
              >
                Cancel
              </button>,
              <button
                key="submit"
                className="update"
                onClick={handleSave}
                disabled={loading}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px", // space between text and loader
                  position: "relative",
                  paddingRight: loading ? "24px" : undefined, // optional, helps maintain size
                }}
              >
                Save
                {loading && (
                  <CircularProgress
                    color="inherit"
                    size={16} // slightly bigger than 10 for visibility
                  />
                )}
              </button>,
            ];
          }
          return [
            <button
              key="back"
              className="cancel"
              onClick={handleBackAndCancelButton}
            >
              Cancel
            </button>,
            <button key="submit" className="update" onClick={handleAdd}>
              Add
            </button>,
          ];
        }
        return [
          <button key="back" className="cancel" onClick={handleCancelButton}>
            Cancel
          </button>,
        <button
          key="submit"
          disabled={
            step === 3 &&
            (
              // Case 1: shipment validation
              (formFields?.step1?.profileType?.value !== "nonshipment"
                ? formFields?.step3?.locations
                    ?.filter((loc) =>
                      ["origin", "destination"].includes(
                        loc[loc?.currentLocation]?.shipping?.value?.toLowerCase()
                      )
                    )
                    ?.filter(
                      (loc) =>
                        loc?.currentLocation !== "" &&
                        loc[loc?.currentLocation]?.pointName?.value &&
                        loc[loc?.currentLocation]?.address?.value &&
                        loc[loc?.currentLocation]?.latitude?.value &&
                        loc[loc?.currentLocation]?.longitude?.value &&
                        loc[loc?.currentLocation]?.radius?.value
                    )?.length < 2
                : false) ||

              // Case 2: nonshipment + BLE + empty location zone
              (
                formFields?.step1?.profileType?.value?.toLowerCase()?.trim() === "nonshipment" &&
                Array.isArray(selectedDeviceProfile) &&
                selectedDeviceProfile.length > 0 &&
                ["ble"].includes(selectedDeviceProfile[0]?.devicemodel?.toLowerCase()) &&
                formFields?.nonshipstep3?.nonshipbleloc?.locationzone?.value?.length === 0
              )
            )
          }
          className="update"
          onClick={handleNext}
        >
          Next
        </button>,
        ];
      }}
    >
      {step !== 1 && type !== "view" && (
        <button
          onClick={handleBackAndCancelButton}
          className="deviceprofile-clone-back-button"
        >
          <img src={BackArrowIcon} alt="Back" width={"16px"} height={"16px"} />
        </button>
      )}
      {type !== "view" && (
        <div className="pt-3" style={{ zIndex: 9999, position: "relative" }}>
          <div
            style={{
              fontWeight: 400,
              fontSize: "15px",
            }}
          >
            {type === "edit" ? "Edit" : "Add"} device profile
          </div>
        </div>
      )}

      {step === 1 && <CreateDeviceProfileStep1 />}

      {step === 2 && <CreateDeviceProfileStep2 />}

      {step === 3 &&
      Array.isArray(selectedDeviceProfile) &&
      selectedDeviceProfile.length > 0 &&
      ["gat", "ble"].includes(selectedDeviceProfile[0]?.devicemodel?.toLowerCase()) && (
        formFields?.step1?.profileType?.value?.toLowerCase().trim() !== "nonshipment" ? (
          <CreateDeviceProfileStep3 />
        ) : (
          <CreateNonShipDeviceProfileStep3 />
        )
      )
    }
        {/* {step === 3 &&
        Array.isArray(selectedDeviceProfile) &&
        selectedDeviceProfile.length > 0 &&
        selectedDeviceProfile[0]?.devicemodel?.toLowerCase() === "ble" && (
          formFields?.step1?.profileType?.value !== "nonshipment"?
        "<CreateNonShipDeviceProfileStep3/>"
          :<CreateNonShipDeviceProfileStep3/>
        )
        } */}

      {step === 4 &&
        Array.isArray(selectedDeviceProfile) &&
        selectedDeviceProfile.length > 0 &&
        selectedDeviceProfile[0]?.devicemodel?.toLowerCase() === "gat" && (
          <CreateDeviceProfileStep4 />
        )}

      {step === -1 && <CreateDeviceProfileStepReview />}
    </Modal>
  );
}

export default CreateDeviceProfile;
